import { render, staticRenderFns } from "./CreatorPlatform.vue?vue&type=template&id=4f8308ba&scoped=true&"
import script from "./CreatorPlatform.vue?vue&type=script&lang=js&"
export * from "./CreatorPlatform.vue?vue&type=script&lang=js&"
import style0 from "./CreatorPlatform.vue?vue&type=style&index=0&id=4f8308ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8308ba",
  null
  
)

export default component.exports